export default {
    assigned_to_name: "Nombre",
    assigned_to_username: "Usuario",
    assigned_to_email: "Correo",
    assigned_to_entity_name: "Nombre de la entidad"
}